if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
var viewportmeta = document.querySelectorAll('meta[name="viewport"]')[0];
if (viewportmeta) {
viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0';
document.body.addEventListener('gesturestart', function() {
viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
}, false);
}
}

$(window).load(function() {
  $('a.image-link > img').setAllToMaxHeight();
});

// Caroline Schnapp - current nav
$(function() {
  $('nav a').each(function() {
    if ($(this).attr('href')  ===  window.location.pathname) {
      $(this).addClass('current');
    }
  });
});

// Initiate jQuery tabs on product.liquid
$(function() {
	$( "#tabs" ).appendTo('#details').tabs();
});

// Custom checkboxes on product.liquid
$(function(){
	$('input').customInput();
	$('.toggle').each(function(){
		$('div:first',this).addClass('first');
		$('div:last',this).addClass('last');	
	}); 
	
});

// Cloudzoom on product.liquid
$(document).ready(function () {
	if (document.documentElement.clientWidth > 768) {
		$('#zoom1').attr('rel','adjustX: 29')
	};
	$('.cloud-zoom, .cloud-zoom-gallery').CloudZoom();
});

// cart button disable / easily tweaked
jQuery(document).ready(function($) {
	$('#buy-button').attr('disabled','disabled').addClass('disabled');
	$('.check').click(function(){
	    if (this.checked) {
	        $('#buy-button').removeAttr('disabled').removeClass('disabled')
	    }
	});
	$('.custom-checkbox > label').hover(
	  function () {
		$(this).siblings('span').appendTo('#variants ol').css("display","block");
	  },
	function () {
		$('ol > span.size-availability').insertAfter(this).css("display","none");
	  }
	);

// Colour picker (could/should be opposite implementation? i.e. select menu w/ custom css list.)	
	$('ul#color-picker').each(function()
	{
	   var select=$(document.createElement('select')).insertBefore($(this).hide());
	   $('>li a', this).each(function()
	   { 
	 option=$(document.createElement('option')).appendTo(select).val(this.href).html($(this).html());
	   });
	   select.change(function(){
	    //alert('url = ' + this.value );
	    window.location.href = this.value;
	  })
	});
});

/**
*	Site-specific configuration settings for Highslide JS
*/
hs.graphicsDir = 'http://static.shopify.com/s/files/1/0069/5872/t/1/assets';
hs.outlinesDir = '/';
hs.showCredits = false;
hs.creditsPosition = 'bottom left';
hs.outlineType = 'custom';
hs.width = 800;
hs.align = 'center';
hs.allowWidthReduction = true;
hs.allowHeightReduction = true;
